import type { Error } from '../types';

export const mustStartWith =
  (value: string | undefined, message?: Error['message']) =>
  (inputValue: string | undefined): Error => ({
    valid: !value || !inputValue || inputValue.startsWith(value),
    message
  });
